import React from 'react';

import classes from './AboutTitle.module.scss';

const title = (props) => (
  <h2 className={classes.Title}>{props.children}</h2>
);

export default title;